module.exports = __webpack_public_path__ + "static/media/skip.a15fe80c.svg";